import "./svg/truck-body.svg"

export default {
    name: "truck-body",
    viewBox: "381 229",
}
